import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Message from '../../utils/Message';
import Loader from '../../utils/Loader';
import CardImageModal from '../CardImageModal';
import QRCode from 'react-qr-code';
import { useLocation } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import {
  Table,
  Tabs,
  Input,
  DatePicker,
  Select,
  Button,
  Skeleton,
  List,
} from 'antd';
import SummaryHeader from './SummaryHeader';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import { CSVLink } from 'react-csv';
const MultiTabReportTable = ({
  report,
  projectId,
  filter,
  setFilter,
  loading2,
}) => {
  const location = useLocation();
  const { Option } = Select;
  const [tableRowsData, setTableRowsData] = useState({ columns: [], rows: [] });
  const [csvData, setCsvData] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [responseTableData, setResponseTableData] = useState('');
  const [queryFields, setQueryFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState('');

  const [loggedInUser] = useState(location.state);
  const user = JSON.parse(localStorage.getItem('centralize-admin-data'));

  const [urlData, setUrlData] = useState('');
  const [imageModal, setImageModal] = useState(false);
  const toggleImage = () => setImageModal(!imageModal);

  const today = new Date();
  const csvDate = `${today.getFullYear()}_${
    today.getMonth() + 1
  }_${today.getDate()}`;

  const [tabReports, setTabReports] = useState([]); // to render tab reports

  const [onChangeTabReport, setOnChangeTabReport] = useState('');
  const [currentTabReport, setCurrentTabReport] = useState('');

  const [onChangeTableData, setOnChangeTableData] = useState('');
  const [searchText, setSearchText] = useState('');
  const [onClickTabLoading, setOnClickTabLoading] = useState(false);

  useEffect(() => {
    // reset
    setCurrentTabReport('');
    setTabReports('');
    setTableRowsData({ columns: [], rows: [] });

    if (report) {
      const filtered = report.subReports
        ? report.subReports.filter((e) => e.reportType === 'multi-tabs-report')
        : [];

      if (filtered) {
        setTabReports(filtered);
      }
      if (filtered) {
        const activeReport = filtered[0];
        setCurrentTabReport(activeReport);

        const queryFiltered = activeReport.query
          ? activeReport.query.filter(
              (e) => e.field === 'status' || e.field === 'Status'
            )
          : [];
        // add status field if it's required in req.body
        if (queryFiltered.length) {
          const newAr = [];
          activeReport.query.forEach((e) => {
            if (e.field === 'status') {
              e.value = e.dropdown[0];
            }
            if (e.field) {
              newAr.push(e);
            }
          });
          setQueryFields(newAr);
          setLoading(true);

          let newArr = {};
          queryFiltered.forEach((e) => {
            if (e.dropdown[0]) {
              newArr[e.field] = e.dropdown[0] ? e.dropdown[0] : '';
            }
          });
          newArr.token = user.accessToken;
          newArr.campaignId = loggedInUser ? loggedInUser.campaignId : '';
          // get data from client

          if (newArr.token && Object.values(newArr).length) {
            axios
              .post(activeReport.endpoint, newArr)
              .then((data) => {
                if (data.data) {
                  setResponseTableData(data.data.data);
                  setLoading(false);
                  setErrorMsg('');
                  // set initial load to false
                }
              })
              .catch((err) => {
                setResponseTableData('');
                setErrorMsg(err.response ? err.response.data.error : '');
                setLoading(false);
              });
          }
        } else {
          // check query exist or not
          const newArr2 = [];
          activeReport.query &&
            activeReport.query.forEach((e) => {
              if (e.field) {
                newArr2.push(e);
              }
            });
          setQueryFields(newArr2);

          setLoading(true);
          // get data from client

          axios
            .post(activeReport.endpoint, {
              token: user.accessToken,
              campaignId: loggedInUser ? loggedInUser.campaignId : '',
            })
            .then((data) => {
              if (data.data) {
                setResponseTableData(data.data.data);
                setLoading(false);
                setErrorMsg('');
              }
            })
            .catch((err) => {
              setResponseTableData('');
              setErrorMsg(err.response ? err.response.data.error : '');
              setLoading(false);
            });
        }
      }
    }
  }, [report]);

  // get csv and table rows data here
  function getTableData(activeReport, currentData) {
    const column = activeReport.header
      ? activeReport.header.map((each) => {
          // console.log('hello each', each)
          return {
            title: each.label || each.title,
            dataIndex: each.field || each.key,
            key: each.field || each.key,
            label: each.label || each.title,
            sortDirections: ['descend', 'ascend'],
            sorter: (a, b) => {
              if (/^\d/.test(a[each.field || each.key])) {
                return a[each.field || each.key] - b[each.field || each.key];
              } else {
                return a[each.field || each.key]
                  ? a[each.field || each.key].localeCompare(
                      b[each.field || each.key]
                    )
                  : a[each.field || each.key];
              }
            },
          };
        })
      : [];

    let data = { columns: column, rows: [] };

    // added filter empty res data
    if (!currentData) {
      setTableRowsData({ columns: data.columns, rows: data.rows });
      setCsvData([]);
      return;
    }

    const hasImage = activeReport.header.filter((e) => e.type === 'image');
    const hasQrCode = activeReport.header.filter((e) => e.type === 'qrCode');

    let imageName = '';
    if (
      activeReport.reportType === 'Action' ||
      report.reportType === 'receipt-validation'
    ) {
      const hasImage = activeReport.header.filter((e) => e.type === 'image');

      const newD = currentData.map((each) => {
        let data = { ...each };

        data.longText = data.message;

        if (data.message) {
          data.message = '';
        }

        // console.log('hasImage', hasImage);
        // render image url
        if (hasImage) {
          // get image  object key
          hasImage.forEach((image, i) => {
            imageName = image.field;

            data[imageName] = (
              <LazyLoadImage
                src={each[imageName]}
                alt="-"
                style={{ objectFit: 'contain' }}
                width="50px"
                height="50px"
                onClick={() => {
                  toggleImage();
                  setType(each.name ? each.name : data[imageName]);
                  setUrlData(
                    data[image.field].props
                      ? data[image.field].props.src
                      : data[image.field]
                  );
                }}
              />
            );
          });
        }
        if (hasQrCode) {
          hasQrCode.forEach((qr, i) => {
            let qrCodeText = qr.field;

            if (data[qr.field]) {
              data[qrCodeText] = (
                <QRCode
                  id="QRCode"
                  size={256}
                  style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                  value={
                    data[qr.field].props
                      ? data[qr.field].props.src
                      : data[qr.field]
                  }
                  viewBox={`0 0 256 256`}
                  onClick={() => onImageDownload(qrCodeText)}
                />
              );
            }
          });
        }
        // data.id = (
        //   <div style={{ cursor: 'pointer' }} onClick={() => getReport(each)}>
        //     <i className="far fa-edit"></i>
        //   </div>
        // );
        return data;
      });
      data.rows = newD ? newD : [];
    } else {
      // render image url
      if (hasImage) {
        const newD = currentData.map((each) => {
          // console.log('each', each);
          let data = { ...each };
          // has image
          // get image  object key
          if (hasImage) {
            // get image  object key
            hasImage.forEach((image, i) => {
              imageName = image.field;

              data[imageName] = (
                <LazyLoadImage
                  src={each[imageName]}
                  alt="-"
                  style={{ objectFit: 'contain' }}
                  width="50px"
                  height="50px"
                  onClick={() => {
                    toggleImage();
                    setType(each.name ? each.name : data[imageName]);
                    setUrlData(
                      data[image.field].props
                        ? data[image.field].props.src
                        : data[image.field]
                    );
                  }}
                />
              );
            });
          }
          if (hasQrCode) {
            hasQrCode.forEach((qr, i) => {
              let qrCodeText = qr.field;

              if (data[qr.field]) {
                data[qrCodeText] = (
                  <QRCode
                    id="QRCode"
                    size={256}
                    style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                    value={
                      data[qr.field].props
                        ? data[qr.field].props.src
                        : data[qr.field]
                    }
                    viewBox={`0 0 256 256`}
                    onClick={() => onImageDownload(qrCodeText)}
                  />
                );
              }
            });
          }
          return data;
        });
        data.rows = newD ? newD : [];
      } else {
        data.rows = currentData ? currentData : [];
      }
    }
    // console.log('data.columns', column);
    setTableRowsData({ columns: data.columns, rows: data.rows });

    setCsvData(currentData);
  }

  useEffect(() => {
    if (responseTableData) {
      // console.log('loading 3');
      getTableData(currentTabReport, responseTableData);
    }
  }, [responseTableData]);

  // get report row data when edit button clicked
  // function getReport(curReport) {
  //   // setCurrentReportRowData(curReport);
  // }

  const resetInput = () => {
    const arr = [];
    // empty the value to clear out
    const activeReport = onChangeTabReport
      ? onChangeTabReport
      : currentTabReport;

    const tableRowsArr = onChangeTableData
      ? onChangeTableData
      : responseTableData;

    activeReport.query &&
      activeReport.query.forEach((e) => {
        e.value = '';
        arr.push(e);
      });
    setQueryFields(arr);
    getTableData(activeReport, tableRowsArr);
  };

  function queryObjectChange(value, index) {
    // reset the filter and isUpdated
    let newArr = [...queryFields];
    newArr[index].value = value;
    setQueryFields(newArr);
  }

  function clickFilter() {
    // if filter return new table data
    setOnClickTabLoading(true);
    const activeReport = onChangeTabReport
      ? onChangeTabReport
      : currentTabReport;
    let newArr = {};
    queryFields.forEach((e) => {
      if (!e.value) return;
      newArr[e.field] = e.value;
    });

    newArr.token = user.accessToken;
    newArr.campaignId = loggedInUser ? loggedInUser.campaignId : '';

    if (newArr.token && Object.values(newArr).length) {
      axios
        .post(activeReport.endpoint, newArr)
        .then((data) => {
          if (data.data) {
            setOnChangeTableData(data.data.data);
            getTableData(activeReport, data.data.data);
            setOnClickTabLoading(false);
            setErrorMsg('');
          }
        })
        .catch((err) => {
          setErrorMsg(err.response ? err.response.data.error : null);
          setOnClickTabLoading(false);
        });
    }
  }

  const onDateChange = (value, index) => {
    let newArr = [...queryFields];
    newArr[index].value = value;
    setQueryFields(newArr);
  };

  function onClickTab(key) {
    setOnClickTabLoading(true);

    const activeReport = tabReports[key];
    setOnChangeTabReport(activeReport);

    let newArr = {};
    const newAr = [];
    // reset query
    activeReport.query.forEach((e) => {
      if (e.field === 'status') {
        e.value = e.dropdown[0];
      }
      if (e.field) {
        newAr.push(e);
      }
    });
    setQueryFields(newAr);

    newArr.token = user.accessToken;
    newArr.campaignId = loggedInUser ? loggedInUser.campaignId : '';

    axios
      .post(activeReport.endpoint, newArr)
      .then((data) => {
        if (data.data) {
          // console.log('activeReport', activeReport);
          setOnChangeTableData(data.data.data);
          getTableData(activeReport, data.data.data);
          setOnClickTabLoading(false);
          setErrorMsg('');
        }
      })
      .catch((err) => {
        setErrorMsg(err.response ? err.response.data.error : '');
        setOnClickTabLoading(false);
      });
  }

  function filterByValue(array, value) {
    return array.filter((data) => {
      return (
        JSON.stringify(data).toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
    });
  }

  const onSearch = (e) => {
    if (!searchText) return;
    const tableRowsArr = onChangeTableData
      ? onChangeTableData
      : responseTableData;

    const filteredData = filterByValue(tableRowsArr, searchText);
    const curReport = onChangeTabReport ? onChangeTabReport : currentTabReport;

    if (filteredData.length) {
      getTableData(curReport, filteredData);
    } else {
      let newTableData = { ...tableRowsData };
      newTableData.rows = [];
      setTableRowsData(newTableData);
    }
  };

  function searchBarOnChange(value) {
    setSearchText(value);
    const tableRowsArr = onChangeTableData
      ? onChangeTableData
      : responseTableData;
    const report = onChangeTabReport ? onChangeTabReport : currentTabReport;
    if (!value) {
      getTableData(report, tableRowsArr);
      setSearchText('');
    } else {
      const filteredData = filterByValue(tableRowsArr, value);
      if (filteredData.length) {
        getTableData(report, filteredData);
      } else {
        let newTableData = { ...tableRowsData };
        newTableData.rows = [];
        setTableRowsData(newTableData);
      }
    }
  }
  const onImageDownload = (name) => {
    const svg = document.getElementById('QRCode');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');

      toggleImage();
      setType(name);
      setUrlData(pngFile);
      // console.log('png', pngFile);
      // const downloadLink = document.createElement('a');
      // downloadLink.download = 'QRCode';
      // downloadLink.href = `${pngFile}`;
      // downloadLink.click();
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  // console.log('csvData', csvData);
  // console.log('currentTabReport', currentTabReport)

  return (
    <div className="validation-table">
      <>
        {!currentTabReport ? (
          <Message color="warning"> Please select report to display. </Message>
        ) : (
          <>
            {errorMsg ? <Message color="danger"> {errorMsg} </Message> : null}

            <div>
              <CardImageModal
                modal={imageModal}
                toggle={toggleImage}
                urlData={urlData}
                type={type}
              />

              {loading ? (
                <Loader />
              ) : (
                <>
                  {loading2 ? (
                    <Loader />
                  ) : (
                    <SummaryHeader
                      multiTabReport={true}
                      report={report}
                      loggedInUser={loggedInUser}
                    />
                  )}

                  <div
                    style={{
                      background: '#fff',
                      padding: '2rem',
                      borderRadius: '10px',
                    }}
                  >
                    <Tabs
                      defaultActiveKey="0"
                      onChange={onClickTab}
                      items={tabReports.map((rep, idx) => {
                        return {
                          label: rep.name,
                          key: idx,
                          children: (
                            <div>
                              <div className="d-flex justify-content-between py-3 ">
                                <div className="d-flex flex-wrap">
                                  <Input
                                    prefix={<SearchOutlined />}
                                    style={{
                                      width: 200,
                                      marginRight: '1rem',
                                    }}
                                    onChange={(e) =>
                                      searchBarOnChange(e.target.value)
                                    }
                                    placeholder="Search"
                                    value={searchText}
                                    onPressEnter={onSearch}
                                  />
                                  {queryFields.length
                                    ? queryFields.map((query, i) => {
                                        if (!query.field) return;
                                        return (
                                          <div key={i}>
                                            {query.type === 'dropdown' ? (
                                              <div className="mx-1">
                                                <Select
                                                  onChange={(e) =>
                                                    queryObjectChange(e, i)
                                                  }
                                                  defaultValue={query.label}
                                                  style={{
                                                    width: 150,
                                                    marginLeft: '1rem',
                                                  }}
                                                  value={query.value}
                                                >
                                                  {query.dropdown.map(
                                                    (e, i) => {
                                                      return (
                                                        <Option
                                                          value={e}
                                                          key={i}
                                                        >
                                                          {e}
                                                        </Option>
                                                      );
                                                    }
                                                  )}
                                                </Select>
                                              </div>
                                            ) : (
                                              <div>
                                                {query.type === 'date' && (
                                                  <DatePicker
                                                    onChange={(e) =>
                                                      onDateChange(e, i)
                                                    }
                                                    value={query.value}
                                                    placeholder={query.label}
                                                  />
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })
                                    : null}

                                  {queryFields.length > 0 ? (
                                    <>
                                      <Button
                                        onClick={() => clickFilter()}
                                        style={{
                                          backgroundColor: '#051D49',
                                          color: '#fff',
                                        }}
                                      >
                                        Filter
                                      </Button>
                                      <Button
                                        onClick={() => resetInput()}
                                        style={{
                                          backgroundColor: '#051D49',
                                          color: '#fff',
                                        }}
                                      >
                                        Reset
                                      </Button>
                                    </>
                                  ) : null}
                                </div>
                                <Button
                                  icon={<DownloadOutlined />}
                                  size={'middle'}
                                  style={{
                                    backgroundColor: '#051D49',
                                    color: '#fff',
                                  }}
                                >
                                  <CSVLink
                                    data={csvData && csvData}
                                    filename={`${
                                      rep && rep.name
                                    }-${csvDate}.csv`}
                                    style={{ padding: '1rem' }}
                                    headers={
                                      tableRowsData && tableRowsData.columns
                                    }
                                  >
                                    Download Report
                                  </CSVLink>
                                </Button>
                              </div>

                              {onClickTabLoading ? (
                                <Skeleton loading={onClickTabLoading} active>
                                  <List.Item.Meta />
                                  Lorem ipsum dolor sit amet consectetur
                                  adipisicing elit. Harum minus ad itaque nihil
                                  voluptate dignissimos cum sunt earum,
                                  architecto excepturi quas dolor doloremque
                                  impedit. Asperiores unde sunt placeat
                                  consectetur molestiae.
                                </Skeleton>
                              ) : (
                                <Table
                                  rowClassName={(record, index) =>
                                    index % 2 === 0
                                      ? 'table-row-light'
                                      : 'table-row-dark'
                                  }
                                  // className={rep}
                                  columns={
                                    tableRowsData ? tableRowsData.columns : []
                                  }
                                  dataSource={
                                    tableRowsData
                                      ? tableRowsData.rows.map((el, idx) => ({
                                          key: idx,
                                          ...el,
                                        }))
                                      : []
                                  }
                                  bordered
                                  scroll={{ x: 1000 }}
                                  size="small"
                                  pagination={{
                                    position: ['bottomLeft'],
                                  }}
                                />
                              )}
                            </div>
                          ),
                        };
                      })}
                    ></Tabs>
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </>
    </div>
  );
};

export default MultiTabReportTable;
